var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.extras && _vm.extras.length > 0
    ? _c("section", { staticClass: "section-extras mb-4" }, [
        _c("h4", { staticClass: "booking-title" }, [
          _vm._v(_vm._s(_vm.$t("message.booking.payment_step.extras")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card shadow-sm" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm._l(_vm.extras, function(extra, index) {
                return !extra.is_grouped
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "exp",
                          class: { "mb-3": index + 1 < _vm.extras.length }
                        },
                        [
                          _c("div", { staticClass: "checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.preCheckoutData.extra,
                                  expression: "preCheckoutData.extra"
                                }
                              ],
                              ref: "extra" + extra.id,
                              refInFor: true,
                              attrs: {
                                type: "radio",
                                name: "extra",
                                id: "extra" + extra.id
                              },
                              domProps: {
                                value: extra,
                                checked: _vm._q(
                                  _vm.preCheckoutData.extra,
                                  extra
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.applyExtras($event, extra)
                                },
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.preCheckoutData,
                                    "extra",
                                    extra
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "mb-0 d-flex",
                                attrs: { for: "extra" + extra.id }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "justify-content-center align-self-center"
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "pl-2" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm._f("multiLangName")(extra)) +
                                      " "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm._f("currency")(extra.cost)) +
                                      " (+" +
                                      _vm._s(extra.work_hour) +
                                      " " +
                                      _vm._s(
                                        _vm.$tc("message.hour", extra.work_hour)
                                      ) +
                                      ")\n              "
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.preCheckoutData.grouped_extras.length > 0
                ? _c(
                    "section",
                    { staticClass: "mt-3" },
                    _vm._l(_vm.preCheckoutData.grouped_extras, function(
                      groupExtras,
                      index
                    ) {
                      return _c("div", [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("div", { staticClass: "flex-grow-1" }, [
                            _c("div", { staticClass: "exp" }, [
                              _c("div", { staticClass: "checkbox" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.preCheckoutData.extra,
                                      expression: "preCheckoutData.extra"
                                    }
                                  ],
                                  ref:
                                    "extra" +
                                    groupExtras[_vm.dynamicIndex[index]].id,
                                  refInFor: true,
                                  attrs: {
                                    type: "radio",
                                    name: "extra",
                                    id: "groupExtra" + _vm.dynamicIndex[index]
                                  },
                                  domProps: {
                                    value: groupExtras[_vm.dynamicIndex[index]],
                                    checked: _vm._q(
                                      _vm.preCheckoutData.extra,
                                      groupExtras[_vm.dynamicIndex[index]]
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.applyExtras(
                                        $event,
                                        groupExtras[_vm.dynamicIndex[index]]
                                      )
                                    },
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.preCheckoutData,
                                        "extra",
                                        groupExtras[_vm.dynamicIndex[index]]
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "mb-0 d-flex",
                                    attrs: {
                                      for:
                                        "groupExtra" + _vm.dynamicIndex[index]
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "justify-content-center align-self-center"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pl-2" }, [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              groupExtras[
                                                _vm.dynamicIndex[index]
                                              ]
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm._f("currency")(
                                              groupExtras[
                                                _vm.dynamicIndex[index]
                                              ].cost
                                            )
                                          ) +
                                          " (+" +
                                          _vm._s(
                                            groupExtras[_vm.dynamicIndex[index]]
                                              .work_hour
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$tc(
                                              "message.hour",
                                              groupExtras[
                                                _vm.dynamicIndex[index]
                                              ].work_hour
                                            )
                                          ) +
                                          ")\n                    "
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                on: {
                                  click: function($event) {
                                    return _vm.decreaseIndex(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-minus" })]
                            ),
                            _vm._v("  \n              "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                on: {
                                  click: function($event) {
                                    return _vm.increaseIndex(index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-plus" })]
                            )
                          ])
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2871eca1", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2871eca1","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/ExtraForm.vue
// module id = 1730
// module chunks = 0